import { render, staticRenderFns } from "./PostMessages.vue?vue&type=template&id=7e0b421e&scoped=true"
import script from "./PostMessages.vue?vue&type=script&lang=js"
export * from "./PostMessages.vue?vue&type=script&lang=js"
import style0 from "./PostMessages.vue?vue&type=style&index=0&id=7e0b421e&prod&lang=css"
import style1 from "./PostMessages.vue?vue&type=style&index=1&id=7e0b421e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0b421e",
  null
  
)

export default component.exports